import React from "react";
import { createPortal } from "react-dom";

import { SEVERITY_STYLE } from "./severity";
import type { ActiveAnnouncement } from "../../hooks/useAnnouncement";
import ChartiLogoIcon from "../icons/ChartiLogoIcon";

interface Props {
  active: ActiveAnnouncement;
}

export const AnnouncementPage: React.FC<Props> = ({ active }) => {
  const style = SEVERITY_STYLE[active.severity];
  const Icon = style.Icon;

  const body = (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483000,
        background: style.bg,
        color: style.fg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 20,
          maxWidth: 560,
        }}
      >
        <div style={{ opacity: 0.9 }}>
          <ChartiLogoIcon />
        </div>
        <Icon className="w-16 h-16" />
        <h1
          style={{
            fontSize: 28,
            fontWeight: 700,
            margin: 0,
            lineHeight: 1.25,
          }}
        >
          {active.title || "Service notice"}
        </h1>
        <p style={{ fontSize: 16, lineHeight: 1.6, margin: 0, opacity: 0.95 }}>
          {active.message}
        </p>
      </div>
    </div>
  );

  if (typeof document === "undefined") return body;
  return createPortal(body, document.body);
};
